import React, { memo, useState } from "react";

import InfoModalButton from "../../common-components/info-modal-button/info-modal-button";
import UnpaidInfoText from "./unpaid-info/unpaid-info-text";
import UnpaidTable from "./unpaid-table";
import UnpaidChart from "./unpaid-chart";
import NoData from "../../common-components/no-data";
import { Button } from "../../../../../components/buttons";
import LeftInfoModal from "../../../../../components/left-info-modal";
import { images } from "../../../../../assets";
import { ArticleContainer } from "../../clients-dashboard-style";
import { UnpaidContainer } from "./unpaid-style";

import ClientsDashboardServices from "../../../../../services/ClientsDashboardServices";
import { csvExcelBlob, downloadBlob } from "../../../../../utils/utility";
import { UseMediatorDataError } from "../../hooks/useGetMediatorData-types";
import { IGetUnpaidInvoicesData } from "../../../../../services/ClientsDashboardServices.dto";

interface UnpaidDashboardProps {
  data: IGetUnpaidInvoicesData[];
  error: UseMediatorDataError;
  mediatorCode: string;
}

const areEqual = (prevProps: UnpaidDashboardProps, nextProps: UnpaidDashboardProps) => {
  const isEqualData = JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  const isEqualErrorMessage = prevProps.error.unpaid === nextProps.error.unpaid;
  return isEqualData && isEqualErrorMessage;
};

const UnpaidDashboard = memo(({ data, error, mediatorCode }: UnpaidDashboardProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [downloadError, setDownloadError] = useState<string>("");

  const handleDownload = async () => {
    setLoading(true);

    const response = await ClientsDashboardServices.downloadUnpaidDoc({
      setLoading: () => {},
      loader: false,
      mediatorCode,
    });

    if (response.ok) {
      const { content, metadata } = response.data;
      const blob = csvExcelBlob(content);
      downloadBlob(blob, metadata.name);
    } else {
      setDownloadError(response.message);
    }

    setLoading(false);
  };

  const getContent = () => {
    if (error.unpaid) {
      return <NoData message={error.unpaid} />;
    }

    if (!data) {
      return <NoData message="Genera una búsqueda para mostrar datos." />;
    }

    if (data.length === 0) {
      return (
        <NoData message="No se han encontrado recibos impagados para el mediador seleccionado." />
      );
    }

    return (
      <>
        <div className="button-container">
          {loading ? (
            <Button text="Cargando datos" disabled onClick={() => {}} />
          ) : (
            <Button text="Exportar datos" onClick={handleDownload} />
          )}
        </div>
        <ArticleContainer>
          <UnpaidTable data={data} />
        </ArticleContainer>
        <ArticleContainer>
          <UnpaidChart data={data} />
        </ArticleContainer>
      </>
    );
  };

  return (
    <UnpaidContainer>
      {getContent()}
      <div className="info-button-container">
        <InfoModalButton buttonText="Pasos de recobro de una póliza">
          <UnpaidInfoText />
        </InfoModalButton>
      </div>

      <LeftInfoModal
        img={images.IconWarningYellow}
        className="warning"
        mainTitle="Error"
        mainText={downloadError}
        buttonText="Cerrar"
        active={downloadError}
        onClickAccept={() => setDownloadError("")}
        close={() => setDownloadError("")}
        noSecondaryButton
      />
    </UnpaidContainer>
  );
}, areEqual);

export default UnpaidDashboard;
